<div
  class="container"
  *ngIf="!loading"
  style="background-image: url('/assets/grey-world-map_1053-431@2x.png')"
>
<div class="container">
  <div class="row">
    <header class="col-12">
      <h2>
        {{ "contact" | translate }} <strong>{{ "us" | translate }}</strong>
      </h2>
    </header>
  </div>
</div>
    <div class="container">
      <div class="row">
        <div
          class="col-md-3 offset-md-1  branch text-center"
          [ngClass]="{ 'ml-3': i > 0 }"
          *ngFor="let item of branchdata; let i = index"
        >
          <h4
            class="branchName"
            [ngClass]="{ active: selectedId === item.id }"
            (click)="btnClick(item.id)"
          >
            {{ item.branch }}
          </h4>
      </div>
      </div>
  </div>
  <div class="container">
    <div class="row">
    <div class="col-lg-6">
      <div class="social">
        <img src="/assets/Group 19.png" alt="" />
        <span>
         <a href="tel:{{ contactdata?.phone }}"> {{ contactdata?.phone }}</a> 
        </span>
      </div>
      <div class="social">
        <img src="/assets/facebook-logo-button.png" alt="" />
        <span>
          <a href="{{ contactdata?.facebook }}" style="font-size: 11px;" target="_blank">
            {{ contactdata?.facebook }}
          </a>
        </span>
      </div>
      <div class="social">
        <img src="/assets/email.png" alt="" />
        <span>
         <a href="mailto:{{ contactdata?.email }}"> {{ contactdata?.email }} </a>
        </span>
      </div>
      <div class="social">
        <img src="/assets/placeholder.png" alt="" />
        <span>
         <a [href]="'https://www.google.com/maps/search/?api=1&query=' + contactdata?.lat + ',' + contactdata?.long"> {{ contactdata["location_" + currentLang] }} </a>
        </span>
      </div>
    </div>
    <div class="col-lg-6 maps" *ngIf="isBrowser">
      <agm-map
        [zoom]="17"
        [latitude]="contactdata?.lat"
        [longitude]="contactdata?.long"
      >
        <agm-marker
          [latitude]="contactdata?.lat"
          [longitude]="contactdata?.long"
        ></agm-marker>
      </agm-map>
    </div>
  </div>
</div>
</div>
